exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Loader-Loader-Loader{display:inline-block;width:16px;width:1rem;height:16px;height:1rem;margin:-2px 8px 0;margin:-2px .5rem 0;vertical-align:middle}.Loader-Loader-Loader__block{display:block;margin:48px auto;margin:3rem auto}.Loader-Loader-Loader_svg{height:100%;width:100%;-webkit-animation:Loader-Loader-spin .6s linear infinite;animation:Loader-Loader-spin .6s linear infinite}@-webkit-keyframes Loader-Loader-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes Loader-Loader-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", ""]);

// exports
exports.locals = {
	"Loader": "Loader-Loader-Loader",
	"Loader__block": "Loader-Loader-Loader__block",
	"Loader_svg": "Loader-Loader-Loader_svg",
	"spin": "Loader-Loader-spin"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/Loader/Loader.css
// module id = 1007
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20